import {breakpoints, gridGutter } from "@olmokit/core/scss";
import {
  glide,
  Anchors,
  Autoplay,
  Breakpoints,
  Controls,
  // LazyLoad,
  Swipe,
} from "@olmokit/core/glide";
import "@olmokit/core/glide/arrows";
import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: Downloads
 */
 export default function dlSlider(rootSelector) {
  
  const $container = `${rootSelector ? rootSelector + " " : ""}`;
  // console.log(breakpoints.lg);
  const slider = glide(
    $container,
    {
      loop: false,
      // autoplay: 4500,
      killWhen: { above: 99999 },
      bound: true,
      breakpoints: {
        [breakpoints.over]: {
          perView: 4,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter / 2 },
        },
        [breakpoints.xxl]: {
          perView: 4,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter / 2 },
        },
        [breakpoints.xl]: {
          perView: 3,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter * 2 },
        },
        [breakpoints.lg]: {
          perView: 3,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter * 2 },
        },
        [breakpoints.md]: {
          perView: 2,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter * 2 },
        },
        [breakpoints.sm]: {
          perView: 1,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter * 2 },
        },
        [375]: {
          perView: 1,
          gap: gridGutter,
          peek: { before: gridGutter / 2, after: gridGutter * 2 },
        },
      },
    },
    { Anchors, 
      Autoplay, 
      Breakpoints, 
      Controls,
      // LazyLoad, 
      Swipe }
      );
      
      return slider;
      
    }

